import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-profiles-onboarding-modal',
  templateUrl: './profiles-onboarding-modal.component.html',
  styleUrls: ['./profiles-onboarding-modal.component.scss']
})
export class ProfilesOnboardingModalComponent {

  constructor(
    private modalController: ModalController,
    private router: Router,
    private sessionService: SessionService
  ) {}

  async logout() {
    await this.modalController.dismiss(null, 'logout');
    await this.sessionService.logout();
  }

  async connectProfiles() {
    const accountId = this.sessionService.accountId || localStorage.getItem('selectedAccountId');
    await this.modalController.dismiss({ connectNow: true });

    if (accountId) {
      this.router.navigate(['/myaccounts']);
    } else {
      this.router.navigate(['/']);
    }
  }

  async doLater() {
    const accountId = this.sessionService.accountId || localStorage.getItem('selectedAccountId');
    await this.modalController.dismiss({ connectNow: false });

    if (accountId) {
      this.router.navigate(['/dashboard', accountId]);
    } else {
      this.router.navigate(['/']);
    }
  }
}
